export enum SelectedType {
  LPO = 'LPO',
  LOI = 'LOI',
}
